export default "__VITE_ASSET__BaGPJytC__"